<script setup lang="ts">
import { onMounted } from 'vue';
import RadioButton from 'primevue/radiobutton';
import { useCalendarStore } from '@/store';

const emit = defineEmits(['close-confirm-modal', 'document-event']);

const calendarStore = useCalendarStore();

const init = () => (calendarStore.selectedEvent.event_process_type = 'this');

onMounted(() => init());
</script>

<template>
  <div class="modaloption-modal-content min-h-0 p-0 p-4 p-2 p-4">
    <p class="font-bold mb-3">
      <RadioButton
        v-model="calendarStore.selectedEvent.event_process_type"
        input-id="option-this"
        name="event_process_type"
        value="this"
      />
      <label class="ml-1" for="option-this">This event</label>
    </p>
    <p class="font-bold">
      <RadioButton
        v-model="calendarStore.selectedEvent.event_process_type"
        input-id="option-this-futures"
        name="event_process_type"
        value="this_and_futures"
      />
      <label class="ml-1" for="option-this-futures">This and following events</label>
    </p>
  </div>
  <div class="p-dialog-footer document-event-modal-footer flex justify-content-end">
    <AppButton type="secondary" text="Cancel" @click="emit('close-confirm-modal')" />
    <AppButton type="primary" text="Save" @click="emit('document-event')" />
  </div>
</template>

<style scoped lang="scss">
.modaloption-modal-content {
  background: $grayLight;
  max-width: 640px;
  min-width: 480px;
}
</style>
